import { ReactNode } from 'react';
import { GradientText } from '@/components/ui/gradient-text';

interface HeroProps {
  rightContent?: ReactNode;
}

function Hero({ rightContent }: HeroProps = {}) {
  return (
    <div className="w-full py-20 lg:py-40 bg-background text-foreground">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 gap-8 items-start lg:grid-cols-12">
          <div className="flex gap-4 flex-col self-start lg:col-span-5">
            {/*<div>*/}
            {/*  <Badge variant="outline">Free AI-powered Analyser</Badge>*/}
            {/*</div>*/}
            <div className="flex gap-4 flex-col">
              <h1 className="text-5xl md:text-7xl max-w-lg tracking-tighter text-left font-regular">
                Optimize{' '}
                <GradientText colorScheme="brand" animated={true}>
                  Marketing Compliance
                </GradientText>{' '}
                Processes
              </h1>
              <p className="text-xl leading-relaxed tracking-tight text-muted-foreground max-w-md text-left">
                Try our our AI-powered Analyser to see how AI can help you improve your compliance
                marketing processes and team collaborations.
              </p>
            </div>

            {/*<div className="mt-4">*/}
            {/*  <a href="/" className="block">*/}
            {/*    <Announcement*/}
            {/*      themed*/}
            {/*      className="bg-sky-100 text-sky-700 hover:bg-sky-200 transition-colors cursor-pointer"*/}
            {/*    >*/}
            {/*      <AnnouncementTag>New</AnnouncementTag>*/}
            {/*      <AnnouncementTitle>*/}
            {/*        Learn more about Verdea's regulatory platform*/}
            {/*        <ArrowUpRightIcon size={16} className="shrink-0 opacity-70" />*/}
            {/*      </AnnouncementTitle>*/}
            {/*    </Announcement>*/}
            {/*  </a>*/}
            {/*</div>*/}
          </div>
          {rightContent ? (
            <div className="bg-muted rounded-md p-4 bg-transparent self-start lg:col-span-7">
              {rightContent}
            </div>
          ) : (
            <div className="bg-muted rounded-md aspect-square overflow-hidden lg:col-span-7"></div>
          )}
        </div>
      </div>
    </div>
  );
}

export { Hero };
